





















import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
	name: 'NpFieldset',
	props: {
		classes: [Array, Object, String],
		legend: String,
	},
})
export default class NpFieldset extends Vue {
	// Props
	public classes!: any;
	public legend!: string;
}
